import React from "react";
import { Box } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import ReportsHome from "./ReportsHome";
import ReportTemplateEditor from "./templates/ReportTemplateEditor";

// «Reportes» (plugin «Reportes»): las plantillas y el reporte rápido, y el editor de plantillas. Las rutas van anidadas
// aquí y no en mainRoutes porque buildRoutes de Jumbo muta los `children` de las rutas (igual que en Automatizaciones).
const ReportsIndex = () => (
    <Box>
        <Routes>
            <Route index element={<ReportsHome />} />
            <Route path="templates/new" element={<ReportTemplateEditor />} />
            <Route path="templates/:id" element={<ReportTemplateEditor />} />
            <Route path="*" element={<Navigate to="/automations/reports" replace />} />
        </Routes>
    </Box>
);

export default ReportsIndex;
